import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import WKTWriter from '../io/WKTWriter';
import MCIndexNoder from './MCIndexNoder';
import TopologyException from '../geom/TopologyException';
import RobustLineIntersector from '../algorithm/RobustLineIntersector';
import NodingIntersectionFinder from './NodingIntersectionFinder';
var FastNodingValidator = /*#__PURE__*/function () {
  function FastNodingValidator() {
    _classCallCheck(this, FastNodingValidator);
    FastNodingValidator.constructor_.apply(this, arguments);
  }
  _createClass(FastNodingValidator, [{
    key: "execute",
    value: function execute() {
      if (this._segInt !== null) return null;
      this.checkInteriorIntersections();
    }
  }, {
    key: "getIntersections",
    value: function getIntersections() {
      return this._segInt.getIntersections();
    }
  }, {
    key: "isValid",
    value: function isValid() {
      this.execute();
      return this._isValid;
    }
  }, {
    key: "setFindAllIntersections",
    value: function setFindAllIntersections(findAllIntersections) {
      this._findAllIntersections = findAllIntersections;
    }
  }, {
    key: "checkInteriorIntersections",
    value: function checkInteriorIntersections() {
      this._isValid = true;
      this._segInt = new NodingIntersectionFinder(this._li);
      this._segInt.setFindAllIntersections(this._findAllIntersections);
      var noder = new MCIndexNoder();
      noder.setSegmentIntersector(this._segInt);
      noder.computeNodes(this._segStrings);
      if (this._segInt.hasIntersection()) {
        this._isValid = false;
        return null;
      }
    }
  }, {
    key: "checkValid",
    value: function checkValid() {
      this.execute();
      if (!this._isValid) throw new TopologyException(this.getErrorMessage(), this._segInt.getIntersection());
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      if (this._isValid) return 'no intersections found';
      var intSegs = this._segInt.getIntersectionSegments();
      return 'found non-noded intersection between ' + WKTWriter.toLineString(intSegs[0], intSegs[1]) + ' and ' + WKTWriter.toLineString(intSegs[2], intSegs[3]);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._li = new RobustLineIntersector();
      this._segStrings = null;
      this._findAllIntersections = false;
      this._segInt = null;
      this._isValid = true;
      var segStrings = arguments[0];
      this._segStrings = segStrings;
    }
  }, {
    key: "computeIntersections",
    value: function computeIntersections(segStrings) {
      var nv = new FastNodingValidator(segStrings);
      nv.setFindAllIntersections(true);
      nv.isValid();
      return nv.getIntersections();
    }
  }]);
  return FastNodingValidator;
}();
export { FastNodingValidator as default };